import { createContext, useContext } from 'react';
import type { DocController } from './useDocController';

const DocControllerContext = createContext<DocController | null>(null);

export const DocControllerProvider = DocControllerContext.Provider;

export function useDocControllerContext(): DocController {
  const ctx = useContext(DocControllerContext);
  if (!ctx) throw new Error('useDocControllerContext must be used within DocControllerProvider');
  return ctx;
}
